'use client';

import type { SeedingDeliveryAddressItem } from '@musinsa/services-curator';
import { useSyncExternalStore } from 'react';

/**
 * 29CM 배송지 변경 — 선택 결과 client store.
 *
 * 배송지 변경 페이지(별도 라우트)에서 선택한 배송지를 상세 화면으로 전달한다.
 * 같은 모듈 인스턴스를 공유하므로 SPA 라우트 이동 간 유지된다. (수락/신청 시점에 deliveryAddressId 사용)
 */
const store = new Map<number, SeedingDeliveryAddressItem>();
const listeners = new Set<() => void>();

export const setSelectedDeliveryAddress = (
  campaignId: number,
  address: SeedingDeliveryAddressItem,
): void => {
  store.set(campaignId, address);
  for (const listener of listeners) listener();
};

export const useSelectedDeliveryAddress = (
  campaignId: number,
): SeedingDeliveryAddressItem | undefined =>
  useSyncExternalStore(
    (onChange) => {
      listeners.add(onChange);
      return () => listeners.delete(onChange);
    },
    () => store.get(campaignId),
    () => undefined,
  );
